import React, { useState } from "react";
import NormalSignUp from "./NormalSignup";
import FaceSignup from "../FaceAuthentication/FaceSignup";

const App = () => {
  const [activeTab, setActiveTab] = useState("normal");

  return (
    <div className="msh--main bg-img signup-sec ">
      <div className="d-flex justify-content-center text-white">
        <button
          className={`btn me-2 text-white `}
          style={{
            background: activeTab === "normal" ? "#fc7c37" : "#fd7a338f",
          }}
          onClick={() => setActiveTab("normal")}
        >
          Normal Signup
        </button>
        <button
          className={`btn text-white`}
          style={{
            background: activeTab === "biometric" ? "#fc7c37" : "#fd7a338f",
          }}
          onClick={() => setActiveTab("biometric")}
        >
          Biometric Signup
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === "normal" ? <NormalSignUp /> : <FaceSignup />}
    </div>
  );
};

export default App;
